module.exports = __webpack_public_path__ + "static/media/README.4e3f6cd0.md";